import { useTranslation } from 'react-i18next';
import { useTheme } from '../theme/ThemeProvider';

/**
 * Switches between the light and the dark theme, beside the language switcher. A pressed button rather than a
 * pair of options: the label stays "Dark theme" whichever state it is in, so anything reading the page out says
 * the same thing every time and the state is carried by aria-pressed. Only the icon changes.
 */
export function ThemeToggle({ variant = 'bar' }: { variant?: 'bar' | 'menu' }) {
  const { t } = useTranslation();
  const { theme, toggle } = useTheme();
  const dark = theme === 'dark';

  return (
    <button
      type="button"
      className={`btn btn-light theme-toggle theme-toggle--${variant}`}
      aria-pressed={dark}
      aria-label={t('nav.darkTheme')}
      title={t('nav.darkTheme')}
      onClick={toggle}
    >
      <i className={`pi ${dark ? 'pi-sun' : 'pi-moon'}`} aria-hidden="true" />
      {/* Named in the menu, where there is room and no tooltip to hover for. */}
      {variant === 'menu' && <span className="ms-2">{t('nav.darkTheme')}</span>}
    </button>
  );
}
